import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ratingService } from "./rating.service";

const initialState = {
  rating: { ratingSentSuccess: false, loading: false },
};

export const sendFeedback = createAsyncThunk(
  "/rating/sendFeedBack",
  async (data, thunkAPI) => {
    const response = await ratingService.sendFeedBack(data);
    return response.data;
  }
);

export const ratingSlice = createSlice({
  name: "rating",
  initialState,
  extraReducers: {
    [sendFeedback.fulfilled]: (state, action) => {
      state.rating = {
        loading: false,
        ratingSentSuccess: action.payload.success,
      };
    },
    [sendFeedback.pending]: (state, action) => {
      state.rating = { loading: true };
    },
    [sendFeedback.rejected]: (state, action) => {
      state.rating = { loading: false };
    },
  },
});

export default ratingSlice.reducer;
